export { default as IconToggle } from './IconToggle.vue';
